import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardPreviewDesignClassName = css({
  overflowY: 'scroll',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
});

export const cardPreviewCardClassName = css({
  padding: `${Spacing.XL}px 0`,
});

export const desktopCardPreviewCardClassName = css({
  padding: `${Spacing['2XL']}px 0`,
});

export const cardContainerClassName = css({
  padding: `0 ${Spacing.MD}px`,
});

export const desktopCardContainerClassName = css({
  padding: `0 ${Spacing.XL}px`,
});

export const heroClassName = css({
  background: Colors.White,
  borderRadius: 4,
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  padding: `22px ${Spacing.LG}px`,
});

export const wrapperClassName = css({
  width: '100%',
});

export const desktopWrapperClassName = css({
  display: 'flex',
  flexDirection: 'row',
});

export const headerClassName = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const desktopHeaderClassName = css({
  alignItems: 'flex-start',
});

export const subheadingClassName = css({
  color: '#4F5F70',
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.BOLD,
  marginBottom: Spacing['2XS'],
});

export const headingClassName = css({
  color: '#0A2540',
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.BOLD,
});

export const actionClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginTop: Spacing.SM,
  [SMALL_DEVICE_MQ]: {
    marginTop: Spacing.MD,
  },
});

export const desktopActionClassName = css({
  marginLeft: 'auto',
  marginTop: 0,
  [SMALL_DEVICE_MQ]: {
    marginTop: 0,
  },
});

export const buttonClassName = css({
  background: 'var(--card-color-accent)',
  border: 'none',
  borderRadius: 3,
  color: Colors.White,
  minHeight: 36,
  padding: `${Spacing['2XS']}px 10px`,
  transition: '600ms',

  '&:hover': {
    transform: 'scale(1.03)',
  },
});

export const buttonIconClassName = css({
  height: 12,
  position: 'relative',
  top: '-0.5px',
  width: 12,
});

export const buttonTextClassName = css({
  fontFamily: 'Nunito, sans-serif',
  fontSize: 12,
  fontWeight: FontWeight.EXTRA_BOLD,
  whiteSpace: 'nowrap',
});

export const messageClassName = css({
  background: Colors.White,
  borderRadius: 4,
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  marginTop: Spacing.MD,
  padding: Spacing.MD,
});

export const desktopMessageClassName = css({
  maxWidth: '33.3333%',
});

export const textClassName = css({
  background: '#DDD',
  borderRadius: 2,
  height: 8,
  width: '100%',
});

export const dividerClassName = css({
  marginTop: Spacing.XS,
});

export const signatureClassName = css({
  background: '#DDD',
  borderRadius: 2,
  height: 8,
  marginTop: Spacing['2XS'],
  marginLeft: 'auto',
  width: '33.3333%',
});

export const footerClassName = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginTop: Spacing.MD,
  textAlign: 'center',
});

export const desktopFooterClassName = css({
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  marginTop: Spacing.XS,
});
 
export const prefixClassName = css({
  fontWeight: FontWeight.MEDIUM,
  fontStyle: 'italic',
  marginRight: 4,
});

export const suffixClassName = css({
  fontWeight: FontWeight.BOLD,
});

export const footingClassName = css({
  color: '#4F5F70',
  fontSize: 12,
});
